import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ToastContainer } from './components/Toast';
import { Navbar, NavTab } from './components/Navbar';
import { LoginPage } from './pages/LoginPage';
import { StudyPage } from './pages/StudyPage';
import { WordbookPage } from './pages/WordbookPage';
import { ImportPage } from './pages/ImportPage';
import { StatsPage } from './pages/StatsPage';
import { SettingsPage } from './pages/SettingsPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { ConsentPage } from './pages/ConsentPage';

const MainContent: React.FC = () => {
  const { authenticated, loading } = useAuth();
  const [currentTab, setCurrentTab] = useState<NavTab>('study');

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 text-slate-500">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-sm font-medium">正在校验 Passkey 认证状态...</p>
      </div>
    );
  }

  if (!authenticated) {
    return <LoginPage />;
  }

  // When URL pathname is /oauth/consent, prioritize rendering ConsentPage (no default StudyPage)
  const isConsent = typeof window !== 'undefined' && window.location.pathname === '/oauth/consent';
  if (isConsent) {
    return <ConsentPage />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar currentTab={currentTab} onSelectTab={setCurrentTab} />

      <main className="flex-1">
        {currentTab === 'study' && (
          <StudyPage
            onNavigateToImport={() => setCurrentTab('import')}
            onNavigateToWordbook={() => setCurrentTab('wordbook')}
          />
        )}
        {currentTab === 'wordbook' && <WordbookPage />}
        {currentTab === 'import' && (
          <ImportPage
            onNavigateToStudy={() => setCurrentTab('study')}
            onNavigateToWordbook={() => setCurrentTab('wordbook')}
          />
        )}
        {currentTab === 'stats' && <StatsPage />}
        {currentTab === 'settings' && <SettingsPage />}
        {currentTab === 'integrations' && <IntegrationsPage />}
      </main>

      <footer className="py-6 border-t border-slate-200/80 text-center text-xs text-slate-400 bg-white">
        <p>Lexi 英语生词与智能记忆 • 运行于 https://en.lipluscu.com • 基于 FSRS 算法</p>
      </footer>
    </div>
  );
};

export const App: React.FC = () => {
  return (
    <ToastProvider>
      <AuthProvider>
        <MainContent />
        <ToastContainer />
      </AuthProvider>
    </ToastProvider>
  );
};

export default App;
